module.exports = __webpack_public_path__ + "img/circle1yellow.f869a359.png";